// Copyright (c) Ping. All rights reserved.
//
// Single source of truth for the SELF user's profile (display name + avatar) so
// a change made in Settings reflects instantly everywhere: the Settings modal,
// the left sidebar account chip, chat self-bubbles, etc. Before this, each
// surface resolved the avatar independently (and the sidebar didn't at all), so
// an upload only updated the Settings modal until a full reload.
//
// `avatarUrl` is a resolved (presigned) media download URL; `avatarMediaId` is
// the canonical id (stable) used to re-resolve when a URL expires.

import { create } from 'zustand';

interface SelfProfileState {
  readonly displayName: string | null;
  readonly avatarMediaId: string | null;
  readonly avatarUrl: string | null;
  /** Patch any subset; `undefined` fields are left unchanged (pass `null` to clear). */
  setProfile: (patch: {
    displayName?: string | null;
    avatarMediaId?: string | null;
    avatarUrl?: string | null;
  }) => void;
}

export const useSelfProfile = create<SelfProfileState>((set) => ({
  displayName: null,
  avatarMediaId: null,
  avatarUrl: null,
  setProfile: (patch) =>
    set((s) => ({
      displayName: patch.displayName !== undefined ? patch.displayName : s.displayName,
      avatarMediaId: patch.avatarMediaId !== undefined ? patch.avatarMediaId : s.avatarMediaId,
      avatarUrl: patch.avatarUrl !== undefined ? patch.avatarUrl : s.avatarUrl,
    })),
}));
